import _cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
import { getUtcUser, shortcutsDefault } from '@/shared/components/datepicker/utils'

export default {
  state: {
    datepicker: {
      start: moment().subtract(6, 'hours'),
      end: moment(),
      shortcut: 'last6Hours',
      utc: getUtcUser()
    }
  },
  mutations: {
    SET_DATEPICKER (state, value) {
      state.datepicker = Object.assign({}, state.datepicker, value)
    },
    SET_DATEPICKER_BY_SHORTCUT (state, value) {
      const shortcut = shortcutsDefault.find(sc => sc.key === value)

      if (shortcut) {
        state.datepicker = Object.assign({}, state.datepicker, { shortcut: value, start: shortcut.value.start(), end: shortcut.value.end() })
      }
    }
  },
  actions: {},
  getters: {
    FILTERS_DATEPICKER (state) {
      return state.datepicker
    },
    FILTERS_DATEPICKER_TIMESTAMP_UTC_MILLISECONDS (state) {
      const date = _cloneDeep(state.datepicker)
      const start = moment(date.start).isValid() ? date.start : parseInt(date.start)
      const end = moment(date.end).isValid() ? date.end : parseInt(date.end)

      date.start = moment(start).isValid() ? moment(start).utc(true).unix() * 1000 + 60 * (date.utc) * 1000 : date.start
      date.end = moment(end).isValid() ? moment(end).utc(true).unix() * 1000 + 60 * (date.utc) * 1000 : date.end

      return date
    }
  }
}
